import EverTrue from 'app';
import BaseRouter from 'base/base-router';
import IsFlaggedController from 'components/flags/is-flagged-controller';
import EmailController from './email-controller';
import ScheduledEmailDetailController from './scheduled/scheduled-email-detail-controller';
import ThreadDetailController from './threads/thread-detail-controller';

class EmailRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      'outreach/email/drafts': 'emailDrafts',
      'outreach/email/scheduled': 'emailScheduled',
      'outreach/email/sent': 'emailSent',
      'outreach/email/scheduled/:id': 'scheduledEmailDetail',
      'outreach/email/thread/:id': 'threadDetail',
    };
  }

  emailDrafts() {
    EverTrue.execute('setBrowserTitle', 'Outreach');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <EmailController emailTab="Drafts" />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  emailScheduled() {
    EverTrue.execute('setBrowserTitle', 'Outreach');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <EmailController emailTab="Scheduled" />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  scheduledEmailDetail(id) {
    EverTrue.execute('setBrowserTitle', 'Outreach');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <ScheduledEmailDetailController id={id} />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  emailSent() {
    EverTrue.execute('setBrowserTitle', 'Outreach');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <EmailController emailTab="Sent" />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  threadDetail(id) {
    EverTrue.execute('setBrowserTitle', 'Outreach');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <ThreadDetailController id={id} />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }
}

EmailRouter.initClass();
export default EmailRouter;
